import { AUTH_ENDPOINT } from "Constants";
import { LoginInfoRequest, LoginInfoResponse } from "Types";
import { baseApi } from "./base.api";

export const loginInfoApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    loginInfo: build.query<LoginInfoResponse, LoginInfoRequest>({
      query: () => ({ url: `${AUTH_ENDPOINT}/login/info` }),
      providesTags: ["Authentication"],
    }),
  }),
  overrideExisting: false,
});

export const { useLoginInfoQuery } = loginInfoApi;
